import React from "react";
import { UseFormReturn } from "react-hook-form";

import { Avatar, Box, Button, Typography, } from "@mui/material";
import VideocamIcon from '@mui/icons-material/Videocam';

import { t, Trans } from "@lingui/macro";

import { VodSectionProps } from "./models";

import "./style.scss";

import ZplayCheckbox from "commons/fields/zplay-checkbox";
import FileUploadSharpIcon from "@mui/icons-material/FileUploadSharp";
import { Stack } from "@mui/system";


export class VodSection extends React.Component<VodSectionProps & UseFormReturn, {}> {

  render(){
    return(<>
        <Typography
            color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}
            variant="h3"
            textAlign="center"
            mb={3}>
                <Trans id={"df-vod-section"}>Setup vod</Trans>
        </Typography>

        {(!this.props.content?.vodAdditionalInfos || this.props.isVodUpdated) && <Box mb={4}>
            {this.props.fileVideoName === null && <Box className="div-upload-content">
                <Avatar sx={{width: "70px", height: "70px", backgroundColor:"white"}}>
                    <FileUploadSharpIcon sx={{width: "60px", height: "60px", color: "#E9E9E9"}} />
                </Avatar>
                <label>
                    <input
                        style={{ display: "none" }}
                        name="upload-file-video"
                        type="file"
                        onChange={this.props.parseFileVideo} />
                    <Button
                        component="span"
                        variant="contained"
                        color={"primary"}
                        sx={{
                            mt: 2,
                            background: `linear-gradient(279.75deg, #3E0449 -2.65%, #E50146 84.59%)`,
                            boxShadow: `0px 2px 7px 4px rgba(137, 1, 42, 0.25)`
                        }}>
                            <Trans id="df-upload-vod-btn">Seleziona file</Trans>
                    </Button>
                </label>
            </Box>}

            {this.props.fileVideoURL !== null && <Stack alignItems="center">
                <video width="680" height="442" controls>
                    <source src={this.props.fileVideoURL} type="video/mp4" />
                    <Trans id={"df-vod-file-video-error-msg"}>Questo video non è supportato</Trans>
                </video>
            </Stack>}
        </Box>}

        {(this.props.content?.vodAdditionalInfos || this.props.fileVideoName) && 
        <Button 
            component="label" 
            variant="contained" 
            color="secondary" 
            size="small" 
            startIcon={<VideocamIcon fontSize="small"/>}
            sx={{
                background: `linear-gradient(279.75deg, #3E0449 -2.65%, #E50146 84.59%)`,
                mb: 2
            }}>
                Sostituisci video
                <input hidden type="file" onChange={this.props.parseFileVideo} />
        </Button>}

        <Box>
            <ZplayCheckbox
                name={`${this.props.name}.encoding`}
                label={t({
                    id: "cl-manage-encoding",
                    message: "Il video richiede transcodifica",
                })}
                disabled={process.env.REACT_APP_ENCODING_ENABLED === "true"}
                onChange={() => this.props.showEncodingMessage()}
                formState={this.props.formState}
                control={this.props.control}
                trigger={this.props.trigger}
            />
            {this.props.encodingMessage &&
                <Typography
                    variant={"body2"}
                    color={"white"}
                    style={{ float: "right" }}>
                        <Trans id={"df-encodingMessage"}> Con questo flag attivo, verrà eseguita una
                            transcodifica del contenuto basandosi su parametri pre determinati.
                            Per maggiori informazioni e/o per modificare i parametri di transcodifica, fare
                            riferimento al Team Operations.</Trans>
                </Typography>}
        </Box>
    </>)
  }
}